import React from 'react'
import clsx from 'clsx'

import useStyles from './styles'

interface Props {
  className?: string
  center?: boolean
  size?: 'large'
  showOverlay?: boolean
}

const Spinner: React.FC<Props> = ({ className = '', size, center, showOverlay = false }) => {
  const classes = useStyles()

  const spinnerClassNames = clsx(classes.spinner, className, {
    [classes.centered]: center,
    [classes.large]: size === 'large',
  })

  if (showOverlay) {
    return (
      <div className={classes.overlay}>
        <div className={spinnerClassNames} />
      </div>
    )
  }

  return <div className={spinnerClassNames} />
}

export default Spinner
